<script>
  export default {

    data() {
      return {
        options: {},

        currentVehicleId: 1,
        currentVehicleBasedata: {},
        currentVehicleBaseline: {},

        mode: 'general',

        mergedRides: [],

        newRide: {
          position: '',
          name: '',
          road_performance: 0,
          days: 20,
          person: 1,
        },

        vehicleBaselineTmpl: {
          mode: null,
          mobility_travel_general_performance: 0,
          mobility_travel_values: []
        },

      }
    },

    props: ['vehicles', 'baselineVehicles', 'hideCallback', 'month'],

    methods: {

      getBasedata(position) {
        console.log('position', position);
        return this._.find(this.vehicles, ['position', position])
      },

      clearRideEditor() {
        this.newRide = {
            position: null,
            name: '',
            road_performance: 0,
            days: 20,
            person: 1,
        }
      },

      addRide(ride) {
        console.log('addRide', ride);
        let baseline = this._.find(this.baselineVehicles, ['position', ride.position]);
        baseline.mobility_travel_values.push(ride);
        this.mergeRides();
        this.clearRideEditor();
      },

      mergeRides() {
        let rides = [];
        this._.map(this.baselineVehicles, (vehicle) => {
          rides = this._.concat(rides, vehicle.mobility_travel_values);
        });
        this.mergedRides = rides;
      },

      removeRide(ride) {
        console.log('REMOVE', ride);
        let baseline = this._.find(this.baselineVehicles, ['position', ride.position]);
        let indx = baseline.mobility_travel_values.indexOf(ride);
        baseline.mobility_travel_values.splice(indx, 1);
        this.mergeRides();
      },

      modeChanged() {
        console.log('this.mode', this.mode);
        this._.map(this.baselineVehicles, (vehicle) => {
          console.log('this.mode', this.mode);
          vehicle.mode = this.mode;
        });
      }

    },

    mounted() {

      console.log('BASEDATA', this.vehicles);
      console.log('BASELINE', this.baselineVehicles);

      if (this.vehicles || this.vehicles.length > 0) {

        this.options = this.co2Service.getOptions();

        this.vehicles.map((vehicle) => {

          let vehicleBaseline = this._.find(this.baselineVehicles, ['position', vehicle.position]);

          if (!vehicleBaseline) { // Vehicle noch nicht in baseline-daten
            console.log('Vehicle noch nicht in baseline-daten');
            let newVehicleBl = {...this.vehicleBaselineTmpl};
            newVehicleBl.position = vehicle.position;
            newVehicleBl.mobility_travel_values = [];
            newVehicleBl.mode = this.mode;
            this.baselineVehicles.push(newVehicleBl);

            vehicleBaseline = this._.find(this.baselineVehicles, ['position', vehicle.position]);
          }

          if(vehicleBaseline && !vehicleBaseline.mobility_travel_values) {
            this.$set(vehicleBaseline, 'mobility_travel_values', []);
          }

          if(vehicleBaseline) {
            this._.map(vehicleBaseline.mobility_travel_values, (val) => {
              val.position = vehicleBaseline.position;
            });
            this.mode = vehicleBaseline.mode;
          }

          // this.$set(vehicle, 'displayName', (vehicle.name ? vehicle.name : 'Fahrzeug ' + vehicle.position));

          this.mergeRides();

        });

      }
    },

  }

</script>
<style lang="scss">
  .baseline-vehicles {
    label {
      cursor: pointer !important;
    }
  }

</style>
<template>
  <div class="baseline-vehicles">

    <div v-if="!vehicles || vehicles.length < 1" class="text-warning text-center mt-3 mb-5">
      <font-awesome-icon class="fa-fw mr-1" icon="exclamation-triangle"></font-awesome-icon>
      <span>Bisher wurden keine Fahrzeuge im Grunddatensatz angegeben. <router-link
        :to="{ name: 'user.co2rechner.grunddaten' }">Bitte erst anlegen falls vorhanden!</router-link></span>
    </div>

    <div v-else class="vehicle-select-header text-center">

      <b-alert variant="info" show>
        Nur private Fahrten/Arbeitsanreise angeben. Keine Geschäftsreisen.
      </b-alert>

      <span>Erfassung der Fahrten im {{month}}:</span>
      <b-form-group id="group-mobility_travel_mode" class="mt-2" >
        <b-form-radio-group
          id="input-mobility_travel_mode"
          @input="modeChanged"
          v-model="mode"
          :options="options.mobility_travel_mode"
          value-field="value"
          buttons
          class="cursor-pointer"
          size="sm"
          button-variant="outline-secondary"
          name="mobility_travel_mode"
        ></b-form-radio-group>
      </b-form-group>

      <div v-if="mode === 'general'" class="text-left">

        <b-row>
          <b-col md="6" offset-md="3">

            <b-form-group class="mt-2"
                          :id="'group-mobility_travel_general_performance_' + baseline.position"
                          :label-for="'input-mobility_travel_general_performance_' + baseline.position"
                          v-for="baseline in baselineVehicles" :key="baseline.position">
              <template slot="label">
                Fahrleistung Fahrzeug {{ getBasedata(baseline.position).position }} <small
                v-if="getBasedata(baseline.position).name" class="text-primary"> ( {{ getBasedata(baseline.position).name }} )</small> im {{month}}
              </template>
              <b-input-group size="sm">
                <b-form-input
                  :id="'input-mobility_travel_general_performance_' + baseline.position"
                  v-model="baseline.mobility_travel_general_performance"
                  type="number"
                  size="sm"
                  rounded
                ></b-form-input>
                <template slot="append">
                  <b-input-group-text>km</b-input-group-text>
                </template>
              </b-input-group>
            </b-form-group>

          </b-col>
        </b-row>

      </div>

      <div v-else>

        <b-row>
          <b-col md="12" class="text-left" >

            <b-row>
              <b-col md="4" v-for="(ride, index) in mergedRides" :key="index" class="p-0 m-0">
                <div class="border-primary border p-2 m-2 rounded">
                  <div class="text-primary">

                    {{ getBasedata(ride.position).displayName }}

                    <b-button class="float-right p-1" size="sm" rounded variant="danger" v-b-tooltip.hover title="Fahrtblock entfernen" @click="removeRide(ride)">
                      <font-awesome-icon class="fa-fw" icon="times"></font-awesome-icon>
                    </b-button>
                  </div>
                  <div v-if="ride.name">{{ ride.name }}</div>
                  <div><small>{{ ride.road_performance }} km | {{ ride.days }} Tage | {{ ride.person }} Person(en)</small></div>
                </div>
              </b-col>
            </b-row>

          </b-col>
        </b-row>


        <b-row>
          <b-col md="6" offset-md="3">

            <b-card class="mb-2 mt-3" body-class="p-1" border-variant="secondary" align="left">
              <b-card-text>

                <h6 class="mb-3 mt-3 text-info">
                  <font-awesome-icon class="fa-fw mr-1" icon="plus-circle"/>
                  Neue Fahrt erfassen
                </h6>

                <!-- Fahrzeug -->
                <b-form-group id="group-mobility_travel_values_vehicle"
                              label="Fahrzeug:"
                              label-for="input-mobility_travel_values_vehicle">
                  <b-form-select
                    id="input-mobility_travel_values_vehicle"
                    v-model="newRide.position"
                    :options="vehicles"
                    value-field="position"
                    text-field="displayName"
                    size="sm"
                    required
                  ></b-form-select>
                </b-form-group>

                <div v-if="newRide.position">

                  <!--Name-->
                  <b-form-group class="mt-2"
                                id="group-ride_name"
                                label-for="input-ride_name">
                    <template slot="label">
                      Bezeichnung:
                      <small>(z.B. "Fahrt zur Arbeit")</small>
                    </template>
                    <b-form-input
                      id="input-ride_name"
                      v-model="newRide.name"
                      type="text"
                      size="sm"
                      rounded
                    ></b-form-input>
                  </b-form-group>

                  <b-row>
                    <b-col md="6">

                      <!-- Distanz -->
                      <b-form-group id="group-ride_road_performance"
                                    label="Distanz (hin und zurück):"
                                    label-for="input-ride_road_performance">
                        <b-input-group size="sm">
                          <b-form-input
                            id="input-ride_road_performance"
                            v-model="newRide.road_performance"
                            type="number"
                            size="sm"
                            rounded
                          ></b-form-input>
                          <template slot="append">
                            <b-input-group-text>km</b-input-group-text>
                          </template>
                        </b-input-group>
                      </b-form-group>

                    </b-col>
                    <b-col md="6">

                      <!-- Tage -->
                      <b-form-group id="group-ride_days"
                                    label="Anzahl der Fahrten:"
                                    label-for="input-ride_days">
                        <b-input-group size="sm">
                          <b-form-input
                            id="ride_days"
                            v-model="newRide.days"
                            type="number"
                            min="1"
                            max="365"
                            step="1"
                            size="sm"
                            rounded
                          ></b-form-input>
                          <template slot="append">
                            <b-input-group-text>Tage</b-input-group-text>
                          </template>
                        </b-input-group>
                      </b-form-group>


                    </b-col>
                  </b-row>

                  <b-form-group id="group-ride_person"
                                label="Anzahl der Personen im Fahrzeug"
                                label-for="input-ride_person">
                    <b-input-group size="sm">
                      <b-form-input
                        id="input-ride_person"
                        v-model="newRide.person"
                        type="number"
                        min="1"
                        max="100"
                        step="0.5"
                        size="sm"
                        rounded
                      ></b-form-input>
                      <template slot="append">
                        <b-input-group-text>Person(en)</b-input-group-text>
                      </template>
                    </b-input-group>
                  </b-form-group>

                </div>

                <div class="text-right">

                  <b-button class="mr-2" size="sm" rounded variant="warning" @click="clearRideEditor()">
                    <font-awesome-icon class="fa-fw mr-1" icon="times"></font-awesome-icon>
                    <span>Fahrtblock leeren</span>
                  </b-button>

                  <b-button size="sm" rounded variant="success" @click="addRide(newRide)">
                    <font-awesome-icon class="fa-fw mr-1" icon="check"></font-awesome-icon>
                    <span>Fahrtblock hinzufügen</span>
                  </b-button>

                </div>


              </b-card-text>
            </b-card>

          </b-col>
        </b-row>

      </div>

    </div>

  </div>
</template>
